import { registerEscapeHandler } from '@app/_init/utils'
import { useStores } from '@app/hooks'
import React from 'react'

/**
 * At mounting, bind some keys.
 */
export function useKeyBindings(): void {
  const { storeRoot } = useStores()

  React.useEffect(() => {
    // bind ESC key
    registerEscapeHandler(storeRoot)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
